<template>
    <fieldset :disabled="formDisabled">
        <div>
            <!-- <div class="form-group">
                <label class="col-md-2 control-label">Component Age(s)</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'significantPeriodList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <ageSelection :isUnknown="true" :parentFormName="qaqcFieldId + 'pff'" ref="ageSelection"></ageSelection>
                </div>
            </div> -->
            <div class="form-group">
                <label class="col-md-2 control-label">Features</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <div class="well row">
                        <div class="col-md-6">
                            <ul type="none">
                                <li v-for="feature in featureList.filter(x => {return x.featureId < 9})" :key="feature.featureId">
                                    <form class="form-inline inline-container">
                                        <div class="checkbox checkbox-inline">
                                            <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + 'UnknownFeature' + feature.featureId" :value="feature.featureId" />
                                            <label :for="qaqcFieldId + 'UnknownFeature' + feature.featureId">{{feature.description}}</label>
                                        </div>
                                        <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                            v-show="feature.hasCount && selectedList.includes(feature.featureId)"
                                            v-model="countList[feature.featureId]" />
                                    </form>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <ul type="none" >
                                <li v-for="feature in featureList.filter(x => {return x.featureId >= 9 && x.featureId <= 16})" :key="feature.featureId">
                                    <form class="form-inline inline-container">
                                        <div class="checkbox checkbox-inline">
                                            <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + 'uf' + feature.featureId" :value="feature.featureId" />
                                            <label :for="qaqcFieldId + 'uf' + feature.featureId">{{feature.description}}</label>
                                        </div>
                                        <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                            v-show="feature.hasCount && selectedList.includes(feature.featureId)"
                                            v-model="countList[feature.featureId]" />
                                    </form>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Keywords</label>
                <div class="col-md-4">
                    <div class="form-inline">
                        <input type="text" class="form-control" v-model="assemblageDto.keywords"/>
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'keywords'" :hasAppend="true"></qaqcFormFieldSelect>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Feature Inventory</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'unknownFeatureInventoryList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Feature Number</th>
                                <th>Description</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in inventoryList">
                                <td>{{item.featureNumber}}</td>
                                <td>{{item.featureDescription}}</td>
                                <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeInventory(index)"></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div  v-if="!formDisabled" class="form-group">
                <div class="col-md-1 col-md-offset-10">
                    <button class="form-contol btn" v-on:click="$refs['inventoryModal'].open()">Add Inventory</button>
                </div>
            </div>
            <modal ref="inventoryModal">
                <div slot="header" class="row">
                    <h3 class="pull-left">Feature Inventory Entry</h3>
                    <button class="btn pull-right" v-on:click="$refs['inventoryModal'].close()">X</button>
                </div>
                <div slot="body">
                    <div class="form form-horizontal">
                        <div class="">
                            <div class="form-group">
                                <label class="col-md-2">Feature Number</label>
                                <div class="col-md-3">
                                    <input type="text" class="form-control" v-model="inventoryDto.featureNumber"/>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2">Description</label>
                                <div class="col-md-10">
                                    <textarea type="text" class="form-control" rows="6" v-model="inventoryDto.featureDescription"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="inventoryDone()">Done</button>
                        <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="inventoryMore()">More</button>
                    </div>
                </div>
            </modal>
            <div v-if="!(formDisabled || qaqcEnabled)" class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="saveUnknownFeature">Save</button>
            </div>
            <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'unknownFeature'" :completeSection="completeSection"></qaqcFormFieldFooter>
        </div>
    </fieldset>
</template>

<script>
import checkBoxPanel from '../CheckBoxPanel.vue'
import modal from '../Modal.vue'
import loggingService from '../../services/util/loggingService'
import unknownFeatureService from '../../services/siteForm/unknownFeatureService'
import featureService from '../../services/lookup/featureService'
import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'unknownFeatureForm',
    components: {
        checkBoxPanel,
        modal,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            featureList: [],
            selectedList: [],
            countList: [],
            inventoryList: [],
            inventoryDto: {},
            assemblageDto: {}
        }
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                if (!this.qaqcProgressDto.qaqcSelections.unknownFeature) {
                    this.qaqcProgressDto.qaqcSelections.unknownFeature = qaqcService.qaqcSelections().unknownFeature
                }
                return this.qaqcProgressDto.qaqcSelections.unknownFeature
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Unknown Feature Form', message)
        },
        loadData () {
            var crrId = this.crrId
            this.log('Searching for assemblage for crr: ' + crrId)
            return unknownFeatureService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                if (result.data.length > 0) {
                    this.assemblageDto = result.data[0]
                    this.selectedList = this.assemblageDto.assemblageDetailsList.map(x => {
                        return x.featureId
                    })
                    // populate the count
                    this.assemblageDto.assemblageDetailsList.forEach(item => {
                        this.countList[item.featureId] = item.featureCount
                    })
                    this.log('Found one assemblage: ' + this.assemblageDto.keywords)
                    // load inventory items
                    this.inventoryList = []
                    this.assemblageDto.unknownFeatureInventoryList.forEach(item => {
                        this.inventoryList.push(item)
                    })
                } else {
                    this.assemblageDto.culturalResourceRecordingId = crrId
                    this.createInventoryDto()
                    this.log('Nothing found')
                }
                return result
            })
        },
        loadLookups () {
            featureService.listFeature(this.$http).then(response => {
                this.featureList = response.data
            })
        },
        inventoryDone () {
            this.log(`Pushing inventory ${this.inventoryDto.description}, size before ${this.inventoryList.length}`)
            this.inventoryList.push(this.inventoryDto)
            this.log(`Pushing inventory size after ${this.inventoryList.length}`)
            this.createInventoryDto()
            this.$refs.inventoryModal.close()
        },
        inventoryMore () {
            //TODO validation
            this.inventoryList.push(this.inventoryDto)
            this.createInventoryDto()
        },
        createInventoryDto () {
            this.inventoryDto = {
                featureNumber: '',
                description: ''
            }
        },
        saveUnknownFeature () {
            this.assemblageDto.assemblageDetailsList = this.selectedList.map(x => {
                return {
                    parentId: this.assemblageDto.unknownFeatureAssemblageId || 0,
                    assemblageTypeId: 5,
                    featureId: x,
                    featureCount: this.countList[x]
                }
            })
            this.log(`select list size ${this.selectedList.length}`)
            this.log(`assemblage details list size ${this.assemblageDto.assemblageDetailsList.length}`)
            this.assemblageDto.unknownFeatureInventoryList = this.inventoryList.map(x => {
                x.unknownFeatureAssemblageId = this.assemblageDto.unknownFeatureAssemblageId || 0
                return x
            })
            unknownFeatureService.put(this.$http, this.assemblageDto).then(result => {
                this.log('form saved')
                this.loadData()
            })
        },
        removeInventory (index) {
            this.inventoryList.splice(index, 1)
        },
        completeSection (sectionName) {
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveUnknownFeature()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>

<style>
.inline-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.inline-input {
  display: flex;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// UnknownFeatureForm.vue?683a4f40